import React, { useState } from 'react';
import emailjs from 'emailjs-com';

export default function ContactPage() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Log the form data to check if it's populated correctly
        console.log('Form Data:', formData);

        const serviceID = 'service_fcby0ei';
        const templateID = 'template_n8k1dva';
        const userID = 'nOZuCbB3AqCP10Z5U';

        // Prepare the template parameters
        const templateParams = {
            from_name: formData.name,
            from_email: formData.email,
            from_phone: formData.phone,
            message: formData.message,
            to_name: 'Khuliso'
        };

        // Log the template parameters to check if they're populated correctly
        console.log('Template Params:', templateParams);

        emailjs.send(serviceID, templateID, templateParams, userID)
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                alert('Message sent successfully!');
                // Reset the form after submission
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    message: ''
                });
            }, (err) => {
                console.log('FAILED...', err);
                alert('Failed to send message. Please try again later.');
            });
    };

    return (
        <div className="contact-container">
            <section className="hero">
                <div className="hero-background"></div>
                <div className="hero-text hero-card">
                    <h1>Contact Us</h1>
                </div>
            </section>
            <section className="contact-area">
                <h3>How can we help you?</h3>
                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Name..."
                        value={formData.name}
                        onChange={handleChange}
                    />
                    <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Email Address..."
                        value={formData.email}
                        onChange={handleChange}
                    />
                    <input
                        type="tel"
                        id="phone"
                        name="phone"
                        placeholder="Phone number..."
                        value={formData.phone}
                        onChange={handleChange}
                    />
                    <textarea
                        id="message"
                        name="message"
                        placeholder="Message..."
                        value={formData.message}
                        onChange={handleChange}
                    />
                    <button type="submit">Send</button>
                </form>
            </section>
        </div>
    );
}
